<div mat-dialog-title class="dialog-header">
    <span class="dialog-header-icon"><mat-icon>event</mat-icon></span>
    <div>
        <h2>{{ editMode ? 'Editar' : 'Novo' }} Evento</h2>
    </div>
</div>
<div [formGroup]="form">
    <div class="full-container">
        <mat-form-field class="half-container">
            <mat-label>Data do evento</mat-label>
            <input matInput [ngxMatDatetimePicker]="picker" formControlName="date" [min]="currentDateTime">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <ngx-mat-datetime-picker #picker [showSpinners]="true" [showSeconds]="false" [stepHour]="1" [stepMinute]="5"
                [enableMeridian]="false" [defaultTime]="[0,0,0]">
            </ngx-mat-datetime-picker>
            <mat-error>Insira a data</mat-error>
        </mat-form-field>
        <mat-form-field class="full-container">
            <mat-label>Título</mat-label>
            <input matInput type="text" formControlName="title" maxlength="30">
            <mat-hint align="end">{{ form.value.title?.length ?? 0 }} / 30</mat-hint>
            <mat-error>Insira o título</mat-error>
        </mat-form-field>
        <mat-form-field class="full-container">
            <mat-label>Descrição</mat-label>
            <textarea matInput type="text" formControlName="description" maxlength="200" [rows]="editMode ? 1 : 6"
                #descriptionInput></textarea>
            <mat-hint align="end">{{ form.value.description?.length ?? 0 }} / 200</mat-hint>
            <mat-error>Insira a descrição</mat-error>
        </mat-form-field>
        <mat-form-field class="full-container">
            <mat-label>Localização</mat-label>
            <input matInput type="text" formControlName="location" maxlength="100">
            <mat-hint align="end">{{ form.value.location?.length ?? 0 }} / 100</mat-hint>
            <mat-error>Insira a localização</mat-error>
        </mat-form-field>
        <mat-slide-toggle class="half-container" style="padding: 0px 0px 25px 10px;"
            formControlName="selectAssociatesIndividually" color="primary">Selecionar convidados
            individualmente</mat-slide-toggle>
        <mat-form-field class="full-container search-input">
            <mat-label>Núcleo (opcional)</mat-label>
            <mat-select formControlName="locationBranch" (selectionChange)="filterAssociates()">
                <mat-option [value]="null">-</mat-option>
                <mat-option *ngFor="let locationBranch of locationBranches" [value]="locationBranch">
                    {{ locationBranch }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-accordion>
            <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false">
                <mat-expansion-panel-header>
                    <mat-panel-title>
                        Lista de Cooperados
                    </mat-panel-title>
                    <mat-panel-description>
                        Clique para {{ panelOpenState ? 'esconder todos os cooperados.' : 'exibir todos os cooperados.'
                        }}
                    </mat-panel-description>
                </mat-expansion-panel-header>
                <mat-card class="scrollable-list-container">
                    <mat-card-content>
                        <div fxLayout="row" fxLayoutAlign="space-between center">
                            <mat-form-field style="width: 300px; padding-top: 10px;">
                                <mat-label>Pesquisa</mat-label>
                                <input matInput placeholder="Pesquise na tabela"
                                    (keyup)="applyFilter($event.target.value)">
                                <mat-icon matSuffix>search</mat-icon>
                            </mat-form-field>
                            <mat-paginator class="paginator" [pageSize]="20" [pageSizeOptions]="[20, 50, 100]"
                                [showFirstLastButtons]="true">
                            </mat-paginator>
                        </div>

                        <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">

                            <ng-container matColumnDef="select">
                                <th mat-header-cell *matHeaderCellDef>
                                    <mat-checkbox (change)="$event ? masterToggle() : null"
                                        [checked]="selection.hasValue() && isAllSelected()"
                                        [indeterminate]="selection.hasValue() && !isAllSelected()"
                                        matTooltip="Seleciona tudo, inclusive o que não estiver visível pelo filtro."
                                        [disabled]="!this.form.value.selectAssociatesIndividually">
                                    </mat-checkbox>
                                </th>
                                <td mat-cell *matCellDef="let row">
                                    <mat-checkbox (click)="$event.stopPropagation()"
                                        (change)="$event ? selection.toggle(row) : null"
                                        [checked]="selection.isSelected(row)"
                                        [disabled]="!this.form.value.selectAssociatesIndividually">
                                    </mat-checkbox>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="description">
                                <th mat-header-cell *matHeaderCellDef> Descrição </th>
                                <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
                            </ng-container>

                            <ng-container matColumnDef="locationBranch">
                                <th mat-header-cell *matHeaderCellDef> Núcleo </th>
                                <td mat-cell *matCellDef="let element"> {{ element.locationBranch }} </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                    </mat-card-content>
                </mat-card>
            </mat-expansion-panel>
        </mat-accordion>
    </div>
</div>
<mat-dialog-actions>
    <button mat-button (click)="cancel()">Cancelar</button>
    <button mat-flat-button color="primary" (click)="save()">{{ editMode ? 'Atualizar' : 'Criar' }}</button>
</mat-dialog-actions>